import * as Categorias from '../constantes/Categorias.js';
import * as TipoEquipo from '../constantes/TipoEquipo.js';
import { EsObjeto } from './Funciones.js';

export const ConvertirListaNombresEquipo = (lista) => {
  return lista
    ? lista.map((item) => {
        return {
          id: item.id,
          nombre: NombreEquipo(item),
        };
      })
    : [];
};

export const ConvertirListaNombresSeleccion = (lista) => {
  return lista
    ? lista.map((item) => {
        return {
          id: item.id,
          nombre: NombreSeleccion(item),
        };
      })
    : [];
};

export const EncontrarNombreSeleccion = (array, item) => {
  let salida = '';
  if (item !== null) {
    if (item.nombre) {
      salida = NombreSeleccion(item);
    } else if (array.length > 0) {
      for (const element of array) {
        if (Number(element.id) === Number(item.id)) {
          salida = NombreSeleccion(element);
          break;
        }
      }
    }
  }
  return salida;
};

export const NombreEquipo = (equipo) => {
  let texto = '';
  if (equipo) {
    texto = equipo.nombre;
    if (equipo.categoria.codigo !== Categorias.MAYOR) {
      texto += ' [' + equipo.categoria.descripcion + ']';
    }
    if (equipo.pais && equipo.tipoEquipo.codigo !== TipoEquipo.SELECCION) {
      texto += ' (' + equipo.pais.nombre + ')';
    }
  }
  return texto;
};
export const NombreEquipoCategoria = (nombre, categoriaEquipo, categoriaObjeto) => {
  let texto = nombre;
  if (!categoriaObjeto || categoriaEquipo.codigo !== categoriaObjeto.codigo) {
    texto += ' [' + categoriaEquipo.descripcion + ']';
  }
  return texto;
};

export const NombreEquipoRelativo = (equipo, categoria, pais) => {
  let texto = '';
  if (equipo) {
    const idPais = EsObjeto(pais) ? pais.id : null;
    texto = equipo.nombre;
    if (equipo.categoria.codigo !== categoria.codigo) {
      texto += ' [' + equipo.categoria.descripcion + ']';
    }
    if (
      equipo.pais &&
      equipo.tipoEquipo.codigo !== TipoEquipo.SELECCION &&
      (!idPais || equipo.pais.id !== idPais)
    ) {
      texto += ' (' + equipo.pais.nombre + ')';
    }
  }
  return texto;
};

export const NombreEquipoTorneo = (equipo, torneo) => {
  const categoria = torneo && torneo.categoria;
  const pais = torneo && torneo.pais;
  return NombreEquipoRelativo(equipo, categoria, pais);
};

export const NombreSeleccion = (equipo) => {
  let texto = '';
  if (equipo) {
    texto = equipo.nombre;
    if (equipo.categoria && equipo.categoria.codigo !== Categorias.MAYOR) {
      texto += ' [' + equipo.categoria.descripcion + ']';
    }
  }
  return texto;
};
